import { BasketQuote, QuoteExtra } from './types/basket-types';
import { Protection, ProtectionPrefix } from './types/extra-types';

/**
 * Returns protection options considering the current basket context.
 * Unlike quoteProtectionOptions, this function considers what the user has actually selected.
 */
export function basketAwareProtectionOptions(quote: BasketQuote, currentSelectedExtras?: QuoteExtra[]) {
  const extra = quote.availableExtras.find((x) => x.key === Protection.BASE);
  const full = quote.availableExtras.find((x) => x.key === Protection.FULL);

  const currentProtectionSelection = currentSelectedExtras?.find((e) => e.key.startsWith(ProtectionPrefix));

  let protection = extra;

  if (currentProtectionSelection) {
    if (currentProtectionSelection.key === Protection.FULL && full) {
      protection = full;
    } else if (currentProtectionSelection.key === Protection.BASE && extra) {
      protection = extra;
    }
  } else if (extra && full) {
    protection = full;
  }

  return {
    net: protection?.price.net || 0,
    gross: protection?.price.gross || 0,
    available: protection !== undefined && (protection?.price.net || 0) > 0,
    included: protection?.metadata?.protectedAmount || 0,
    max: protection?.metadata?.maxProtection || 0,
    full: extra && full && (full.metadata?.protectedAmount || 0) > (extra?.metadata?.protectedAmount || 0),
    selectedKey: currentProtectionSelection?.key || (protection?.key as string)
  };
}
